import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../api/axios";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  getCountryCommunities,
  unsetCommunity,
} from "../../features/communitiesSlice";
import { findRoleById, loadStatus } from "../../util";
import { inviteUser } from "../../features/usersSlice";
import { closeModal } from "../../features/modalSLice";
import { zodResolver } from "@hookform/resolvers/zod";
import { inviteUserSchema } from "../../schemas";
import Loading from "../../components/loading/Loading";
import { useNotification } from "../../components/notification/NotificationContainer";

const InviteUser = () => {
  const dispatch = useDispatch();
  const communities = useSelector((state) => state.communities.data);
  const province_id = useSelector((state) => state.user.userInfo.province_id);
  const inviteUserLoad = useSelector((state) => state.users.load.inviteUser);
  const [roles, setRoles] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const addNotification = useNotification();

  const {
    register,
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      role_id: "",
      organization_id: "",
      community_id: "",
      department_id: "",
      email: "",
    },
    resolver: zodResolver(inviteUserSchema),
  });
  const watchAllFields = watch();

  //Get register organization, and roles
  const getRegister = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get("/register", {
        params: { id: province_id },
      });
      setRoles(
        response.data.roles.filter(
          (item) => item.name.toLowerCase() !== "super administrator"
        )
      );
      setOrganizations(response.data.organizations);
      setDepartments(response.data.departments);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (!error.response) {
        addNotification(error.response.data.message, "error");
      }
      addNotification(error.message, "warning");
      dispatch(closeModal());
    }
  }, [setRoles]);

  const onSubmit = async (data, e) => {
    e.preventDefault();
    data.province_id = province_id;
    let res;
    try {
      if (
        (findRoleById(roles, data.role_id, "community cordinator") &&
          data.community_id) ||
        !findRoleById(roles, data.role_id, "community cordinator")
      ) {
        res = await dispatch(inviteUser(data));
        if (inviteUser.fulfilled.match(res)) {
          dispatch(closeModal());
          dispatch(unsetCommunity());
          addNotification("User invited successfully", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        addNotification("There is no Community id", "warning");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  //Get Role Values
  useEffect(() => {
    getRegister();
  }, []);
  //Watch values and make community select visible if community cordinator is selected
  useEffect(() => {
    let role;
    if (watchAllFields.role_id) {
      role = roles.find((item) => item.id === watchAllFields.role_id);
    }
    if (watchAllFields.organization_id) {
      setValue("community_id", "");
      dispatch(getCountryCommunities(watchAllFields.organization_id));
    } else {
      setValue("community_id", "");
      dispatch(unsetCommunity());
    }
  }, [watchAllFields.role_id, watchAllFields.organization_id]);

  if (loading === loadStatus.loading) {
    return (
      <div className="overflow-auto min-w-72 sm:min-w-[40rem] w-full h-80 flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <div className="overflow-auto">
      <h3 className="text-center m-7">Invite User</h3>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.email}
            label="Email"
            name="email"
            placeholder="david@examplie.com"
            type="email"
            autoComplete="false"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            errors={errors.organization_id}
            data={[{ id: "", name: "-- Select Location" }, ...organizations]}
            name="organization_id"
            label="Country or Station"
          />
          <SelectField
            register={register}
            errors={errors.role_id}
            data={[{ id: "", name: "-- Select Role" }, ...roles]}
            name="role_id"
            label="Role"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            errors={errors.community_id}
            data={[{ id: "", name: "-- Select Community" }, ...communities]}
            name="community_id"
            label="community"
          />
          <SelectField
            register={register}
            errors={errors.department_id}
            data={[{ id: "", name: "-- Select Department" }, ...departments]}
            name="department_id"
            label="Department"
          />
        </div>
        <ResourseButtons loading={inviteUserLoad} />
      </form>
    </div>
  );
};

export default InviteUser;
